<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "@/router/index.js";
import moment from "moment";
import YTActivitySignOrderState from "@/components/YTActivitySignOrderState/index.vue";
import {userTokenStore} from "@/store/store.js";
import axios from "axios";
import {listBillOrder} from "@/api/bill/bill.js";
import YTOrderState from "@/components/YTOrderState/index.vue"
import YTRefundState from "@/components/YTRefundState/index.vue"

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  paymentTime: [],
  orderNo: null,
  paymentNo: null,
  tradeNo: null
});
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {
      paymentStartDate: formData.paymentTime.length > 0 ? formData.paymentTime[0] : null,
      paymentEndDate: formData.paymentTime.length > 0 ? formData.paymentTime[1] : null,
      orderNo: formData.orderNo,
      paymentNo: formData.paymentNo,
      tradeNo: formData.tradeNo,
    }
    const res = await listBillOrder(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.paymentTime = []
  formData.orderNo = null
  formData.paymentNo = null
  formData.tradeNo = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '微信订单号', key: 'tradeNo', nowrap: true },
  { title: '商户订单号', key: 'paymentNo', nowrap: true },
  { title: '平台订单号', key: 'orderNo', nowrap: true },
  { title: '用户ID', key: 'userId', nowrap: true },
  { title: '用户昵称', key: 'nickname', nowrap: true },
  { title: '用户注册手机号', key: 'phone', nowrap: true },
  { title: '商品名称', key: 'goodsName', nowrap: true },
  { title: '购买数量', key: 'totalQuantity', nowrap: true },
  { title: '使用优惠明细', key: 'discountDetail', align: 'center', sortable: false, nowrap: true },
  { title: '付款时间', key: 'paymentTime', nowrap: true },
  { title: '下单时间', key: 'orderTime', nowrap: true },
  { title: '交易状态', key: 'state', nowrap: true },
  { title: '付款银行', key: 'bankType', nowrap: true },
  { title: '货币种类', key: 'currency', nowrap: true },
  { title: '应结订单金额', key: 'settleAmount', nowrap: true },
  { title: '代金券金额', key: 'wxCouponFee', nowrap: true },
  { title: '微信退款单号', key: 'refundTradeNo', nowrap: true },
  { title: '商户退款单号', key: 'refundNo', nowrap: true },
  { title: '退款金额', key: 'refundAmount', nowrap: true },
  { title: '充值券退款金额', key: 'wxCouponRefundFee', nowrap: true },
  { title: '退款类型', key: 'refundType', nowrap: true },
  { title: '退款状态', key: 'refundState', nowrap: true },
  { title: '手续费', key: 'poundage', nowrap: true },
  { title: '费率', key: 'poundageRate', nowrap: true },
  { title: '订单金额', key: 'orderAmount', nowrap: true },
  { title: '申请退款金额', key: 'appliedRefundAmount', nowrap: true },
])
// 使用优惠明细表头
const headersPromotionDetails = [
  { title: "免费优惠", align: 'center', sortable: false, nowrap: true,
    children: [
      { title: "总优惠额", key: 'free_total', align: 'center', sortable: false, nowrap: true },
      { title: "优惠券信息", key: 'free_ticket',align: 'center', sortable: false },
    ]
  },
  { title: "付费优惠", align: 'center', sortable: false, nowrap: true,
    children: [
      { title: "总优惠额", key: 'payment_total', align: 'center', sortable: false, nowrap: true },
      { title: "优惠券信息", key: 'payment_ticket', align: 'center', sortable: false },
    ]
  }
]
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*下载报表相关*/
// 处理下载订单列表
const handleDownloadList = async (item) => {
  // ElMessage.warning("下载中...");
  let body = {
    paymentStartDate: formData.paymentTime.length > 0 ? formData.paymentTime[0] : null,
    paymentEndDate: formData.paymentTime.length > 0 ? formData.paymentTime[1] : null,
  }
  await downloadFile(
    `${
      import.meta.env.VITE_API_URL
    }/admin/bill/export`,
    body, // 请求体数据
    `账单明细-${moment().format(
      "YYYY-MM-DD_HHmmss"
    )}.csv` // 默认文件名
  );
};
/**
 * 自定义文件名的下载函数
 * @param {string} url - 完整接口URL
 * @param {Object} requestData - 请求体数据
 * @param {string} customFilename - 自定义文件名
 */
const downloadFile = async (url, requestData = {}, customFilename) => {
  try {
    const token = userTokenStore().token;
    const response = await axios.post(url, requestData, {
      responseType: "blob",
      headers: {
        Authorization: token.tokenValue,
        "Login-Type": token.loginType,
        "Content-Type": "application/json",
      },
      validateStatus: (status) => {
        if(status === 400) {
          ElMessage.error("请选择交易结束时间, 请选择交易开始时间")
          return false
        } else if(status === 200) {
          return true
        } else {
          ElMessage.error("文件下载失败");
          return false
        }
      },
    });

    // 创建下载链接
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", customFilename); // 使用传入的自定义文件名
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    return true;
  } catch (error) {
    console.error("文件下载失败:", error);
    // ElMessage.error("文件下载失败");
    return false;
  }
};

/*上传报表相关*/
const upload = ref(null)
// token
const token = userTokenStore().token
// 请求头携带信息
const uploadHeaders = {
  Authorization: token.tokenValue,
  "Login-Type": token.loginType
}
const actionUrl = import.meta.env.VITE_API_URL + "/admin/bill/import"
const handleExceed = (files) => {
  upload.value.clearFiles()
  const file = files[0]
  upload.value.handleStart(file)
}
const onUploadSuccess = async (e) => {
  let data = e.data
  ElMessage.success(`文件上传成功，${data.successCount}条数据成功，${data.errorCount}条数据失败`)
  upload.value.clearFiles()
  await handleSearch()
}
const onUploadError = () => {
  upload.value.clearFiles()
  ElMessage.error("文件上传失败，请检查网络")
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 0;">
    <el-form
      ref="ruleFormRef"
      style="width: 100%;text-align: left;"
      :model="formData"
      label-width="auto"
      label-position="top"
      class="demo-ruleForm"
      status-icon
    >
      <div class="flex_left flex_warp flex_align_t">
        <el-form-item label="付款时间：" prop="paymentTime">
          <div>
            <el-date-picker
                class="mg_r_2"
                v-model="formData.paymentTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择付款时间"
                value-format="YYYY-MM-DD HH:mm:ss"
            />
            <div class="tips_default mg_r_1">可筛选出下单时间与搜索条件内付款时间一致的实付0元订单</div>
          </div>
        </el-form-item>
        <el-form-item label="平台订单号：" prop="orderNo">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.orderNo" placeholder="请输入平台订单号"></el-input>
        </el-form-item>
        <el-form-item label="商户订单号：" prop="paymentTime">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.paymentNo" placeholder="请输入商户单号"></el-input>
        </el-form-item>
        <el-form-item label="微信订单号：" prop="tradeNo">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.tradeNo" placeholder="请输入微信订单号"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <div class="flex_right mg_b_1" style="align-items: flex-start;">
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="actionUrl"
        :headers="uploadHeaders"
        :limit="1"
        :on-exceed="handleExceed"
        :on-success="onUploadSuccess"
        :on-error="onUploadError"
        :auto-upload="true"
        :show-file-list="false"
      >
        <template #trigger>
          <el-button style="color: #FFF;" type="primary">上传</el-button>
        </template>
      </el-upload>
      <!-- <v-btn
        class="mg_l_1"
        color="#4CAF50"
        @click="handleDownloadList(drawerCache)"
      >
        下载
      </v-btn> -->
      <el-button class="mg_l_1" style="color: #FFF;" type="success" @click="handleDownloadList(drawerCache)">下载</el-button>
    </div>
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="loading"
          :items-per-page="$globalPageSize"
          :no-data-text="'没有更多数据了~'"
          hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>
          <template v-slot:item.discountDetail="{ item }">
            <v-data-table
                v-if="!loading"
                :headers="headersPromotionDetails"
                :items="[item.discountDetail]"
                :loading="loading"
                :no-data-text="'没有更多数据了~'"
                density="default"
                hover
            >
              <template v-slot:item.free_total="{ item }">
                {{item?.freeDiscount?.totalDiscountAmount ? `￥${item?.freeDiscount?.totalDiscountAmount}` : `—`}}
              </template>
              <template v-slot:item.free_ticket="{ item }">
                <div class="flex" v-if="item?.freeDiscount?.ticketList.length > 0">
                  <div class="flex_center" v-for="(ticket, ticketIndex) in item.freeDiscount.ticketList" :key="`freeDiscount.ticketList${ticketIndex}`">
                    <div v-show="ticketIndex > 0">、</div>
                    <div>
                      **{{ticket.ticketName}}×{{ticket.quantity}}张(抵扣￥{{ticket.discountAmount}}{{ticket.purchaseAmount ? `，购买价￥${ticket.purchaseAmount}` : ``}})
                    </div>
                  </div>
                  <div v-if="item.freeDiscount.vipDiscountAmount > 0">、VIP会员优惠-￥{{item.freeDiscount.vipDiscountAmount}}</div>
                </div>
                <div v-else>—</div>
              </template>
              <template v-slot:item.payment_total="{ item }">
                {{item?.paidDiscount?.totalDiscountAmount ? `￥${item?.paidDiscount?.totalDiscountAmount}` : `—`}}
              </template>
              <template v-slot:item.payment_ticket="{ item }">
                <div v-if="item?.paidDiscount?.ticketList.length > 0">
                  <div class="flex_center" v-for="(ticket, ticketIndex) in item.paidDiscount.ticketList" :key="`paidDiscount.ticketList${ticketIndex}`">
                    <div>
                      **{{ticket.ticketName}}×{{ticket.quantity}}张(抵扣￥{{ticket.discountAmount}}{{ticket.purchaseAmount ? `，购买价￥${ticket.purchaseAmount}` : ``}})
                    </div>
                  </div>
                  <div v-if="item.paidDiscount.vipDiscountAmount > 0">、VIP会员优惠-￥{{item.paidDiscount.vipDiscountAmount}}</div>
                </div>
                <div v-else>—</div>
              </template>
              <template v-slot:bottom>
              </template>
            </v-data-table>
          </template>
          <template v-slot:item.refundState="{ item }">
            <YTRefundState :state="item.refundState"></YTRefundState>
          </template>
          <template v-slot:item.state="{ item }">
            <YTOrderState :state="item.state"></YTOrderState>
          </template>
          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>
